<template>
  <div class="setting-popup art-setting" v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      选择艺术字
    </div>
    <div class="setting-popup__content">
      <div class="art-content">
        <div  @click.stop="changeArt({val: 'None', name: '无'}, $event)" class="art-img" :class="{'select-art': !artType}">
          <img class="no-art" src="/static/svg/nohand.svg"/>
        </div>
        <div>无</div>
      </div>
      <div class="art-content" v-for="item in styleObject" :key="item.val">
        <div class="art-img" :class="{'noclick': item.dynamic && special,
        'select-art': item.active}" @click.stop="changeArt(item, $event)">
          <img :src="item.thumbnailUrl"/>
          <img v-if="item.gifUrl" class="mask-gif" :src="item.gifUrl">
          <span v-if="item.isVip && !UserEquity.exclusive" class="label" :class="getBadgeClassName(4, 'enterpriseS')">VIP</span>
        </div>
        <div>{{item.name}}</div>
      </div>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import popup from '../mixins/popup'
import textArtStyle from '../mixins/textArtStyle'
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [popup, textArtStyle, vipBadge],
  data () {
    return {
      popupType: 'artTextSetting',
      special: false,
      artType: ''
    }
  },
  computed: {
    ...mapGetters([
      'UserEquity',
    ])
  },
  watch: {
    'boxData.judgeBox': function (val) {
      if(val) {
        this.initData()
      } else {
        this.$bus.emit('artTextClose', this.boxData.data.from)
      }
    },
    'sprite.artType': function (val) {
      this.sprite.opHelper.isSvip = false;
      this.sprite.opHelper.judgeItemLevel = false;
      this.$bus.emit('judgeItemPayType_vue', this.sprite);
    },
  },
  methods: {
    initData() {
      if(!this.sprite) return;
      this.artType = this.sprite.artType;
      this.styleObject.forEach((item) => {
        if(item.val === this.sprite.artType) {
          item.active = true;
        }else {
          item.active = false;
        }
      })
      this.special = this.hasSpecialEffect(this.sprite.effect.code)
    },
    changeArt(item, e) {
      this.$bus.emit('artTextSetting', item)
      let data = {
        artType: ''
      }
      if(item.val !== 'None') {
        data.artType = item.val;
        data.artStyle = this.getStyle(item.val, item.color, this.sprite.font.fontSize);
      }
      if(this.special && item.dynamic) {
        data.effectCode = this.sprite.effect.code;
        this.sprite.updateEffect({code: 'FadeIn'})
      }
      if(this.artType === item.val) return;
      this.artType = data.artType;
      $('.select-art').removeClass('select-art')
      if(!e.target.className) {
        e.target.parentNode.classList.add("select-art")
      } else {
        e.target.classList.add("select-art")
      }
      // this.sprite.artSetting(data, true)

      this.$analysis({
        category: 'material_setting_panel',
        action: 'click_text_effect_change_' + item.val,
        label: '素材设置面板_文字_效果更改_' + item.name
      })
    },
    hasSpecialEffect (code) {
      return /^(?:appear|type|write|bounce|roll)$/i.test('' + code);
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 262px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__content {
    margin: 17px 0;
    padding:0 21px 0 17px;
    width: 106%;
    height: 460px;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    overflow-x: visible;
    overflow-y: scroll;

    &:first-child {
      margin-top: 0;
    }

    &:nth-child(2) {
      margin-top: 0;
    }

    div {
      text-align: center;
      margin-top: 10px;
    }
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }
}

.art-content {
  width: 100px;
}

.select-art.art-img {
  border-color: #627DF2;
}
.art-img {
  position: relative;
  width: 100px;
  height: 55px;
  border: 1px solid #ddd;
  line-height: 69px;
  box-sizing: content-box;
  overflow: hidden;
  cursor: pointer;

  .no-art {
    width: 40%;
    height: 40%;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .mask-gif {
    position: absolute;
    display: none;
    left: 0;
    top: 0;
  }

  &:hover .mask-gif {
    display: block;
  }
}
.label{
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 30px;
  height: 18px;
  // background: #d83d60;
  color: #fff;
  border-radius: 5px;
  line-height: 18px;
}
// .art-img.noclick {
//   cursor: not-allowed;
// }
.enterpriseS {
  width: 50px;
  height: 16px;
  // content: url(../../assets/enterpriseS.png);
  content: url(../../assets/enterpriseSVIP.svg);
}
.pro {
  width: 30px;
  height: 18px;
  content: url(../../assets/pro.png);
}
.proPlus {
  width: 32px;
  height: 18px;
  content: url(../../assets/proPlus.png);
}
</style>



// WEBPACK FOOTER //
// src/components/popups/artTextSetting.vue